/// <summary>
/// This visual provides a list and a edit form for the user notification auto reporting<br/>
/// </summary>    ///
/// <remarks>
/// Author: MKU<br/>
/// Date: 13.04.2026<br/>
/// Copyright ©: EUDT GmbH 2024 <br/>
/// Version-History:<br/>
/// **********************************************************************<br/>
/// *** v1.0.0 - 13.04.2026                                            ***<br/>
/// **********************************************************************<br/>
/// * - generates basic functionality                                    *<br/>
/// **********************************************************************<br/>
jQuery.widget("bluaul.UserNotificationAutoReport", jQuery.common.vcBaseV4, {

    _create: function () {
        this._createVisual(402);
        this._super();
    },
    _initHTML: function () {
        var me = this;
        try {
            me._setRoot(".vc-user-notification-autoreport");
            me.myStatus = me.myStatus || {};
            me.myStatus.selectedReportMode = "customXls"; // default mode
            me._buildHtml();
            me._initUserDropdown();
            me._fetchOverview();
            me._fetchAllTopMenuCounts();
            me._setHeightsWidths();
            me._startSendingPoller();
        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {

            me.myHtml.overview.btnNew.off("click").on("click", function () {
                me.myHtml.overview.hide();
                me.myHtml.editForm.show();
                me.myHtml.topmenu.btnCustomXls.button("disable");
                me.myHtml.topmenu.btnStandard.button("disable");
                me.myHtml.editForm.editArea.manualBox.btnSend.button("disable"); // only enable manual execution for existing reports, not for new ones
                me.myHtml.editForm.editArea.manualBox.btnSend.button("option", "label", me.specific.resources.send || "Senden");

                me._resetForm();

                // initialize CLEditor only once
                if (!me._editorInitialized) {
                    me._initTextEditor();
                    me._editorInitialized = true;
                }

                me._setHeightsWidths();

                me._validate();
            });

            me.myHtml.editForm.btnBack.off("click").on("click", function () {
                me.myHtml.editForm.hide();
                me.myHtml.overview.show();
                me.myHtml.topmenu.btnCustomXls.button("enable");
                me.myHtml.topmenu.btnStandard.button("enable");
                me._fetchOverview();
            });

            me.myHtml.editForm.btnSave.off("click").on("click", function () {
                if (!me._validate()) return;
                me._dirty = false;
                me._save();
            });

            me.myHtml.editForm.editArea.leftBox.chbActive.off("change").on("change", function () {
                me._dirty = true;
                me._updateSaveButtonStatus();
            });

            me.myHtml.editForm.editArea.leftBox.chbUseNameAsEmailSubject.off("change").on("change", function () {
                if (!me._resetting) { me._dirty = true; me._updateSaveButtonStatus(); }
            });

            me.myHtml.editForm.editArea.leftBox.txtName.off("input blur").on("input blur", function () {
                me._dirty = true;
                me._validateName();
                me._updateSaveButtonStatus();
            });

            me.myHtml.editForm.editArea.leftBox.txtFileName.off("input").on("input", function () {
                if (!me._resetting) { me._dirty = true; me._updateSaveButtonStatus(); }
            });


            me.myHtml.editForm.editArea.rightBox.txtEmails.off("input").on("input", function () {
                me._dirty = true;
                me._updateSaveButtonStatus();
            });            

            me.myHtml.overview.listData.off("click", ".ar-desc-toggle").on("click", ".ar-desc-toggle", function (e) {
                e.stopPropagation();
                var btn = $(this);
                var wrap = btn.prev(".ar-text-wrap");
                var expanded = wrap.toggleClass("expanded").hasClass("expanded");
                btn.find("i").toggleClass("fa-chevron-down", !expanded).toggleClass("fa-chevron-up", expanded);
                btn.attr("aria-expanded", expanded ? "true" : "false");
            });

            me.myHtml.topmenu.btnCustomXls.off("click").on("click", function () {
                me._selectReportMode("customXls");
            });

            me.myHtml.topmenu.btnStandard.off("click").on("click", function () {
                me._selectReportMode("standard");
            });

            me.myHtml.editForm.editArea.rightBox.chbAddToMedia.off("change").on("change", function () {
                if (!me._resetting) { me._dirty = true; me._updateSaveButtonStatus(); }
            });

            me.myHtml.editForm.editArea.signalBox.chbAllSignals.off("change").on("change", function () {
                if (me._resetting) return;
                var isAll = $(this).prop("checked");
                me.myHtml.editForm.editArea.signalBox.divList.find("input[type=checkbox]").prop("disabled", isAll);
                if (isAll) {
                    me.myHtml.editForm.editArea.signalBox.divList.css("opacity", "0.5");
                    me.myHtml.editForm.editArea.signalBox.divList.find("input[type=checkbox]").prop("checked", false);
                }
                else {
                    me.myHtml.editForm.editArea.signalBox.divList.css("opacity", "1");
                }
                me._dirty = true;
                me._validateSignalSelection();
                me._updateSaveButtonStatus();
            });


            me.myHtml.editForm.editArea.manualBox.btnSend.off("click").on("click", function () {
                me._sendManual();
            });



            me.myHtml.overview.listData.off("click", ".ar-icon-delete").on("click", ".ar-icon-delete", function (e) {
                e.stopPropagation();
                var icon = $(this);
                var item = icon.closest(".vc-list-item");
                var id   = parseInt(icon.attr("data-id"), 10);
                if (!id) return;

                me.myHtml.overview.css("opacity", 0.2);
                me.openAskDialog(
                    (me.specific.resources.deleteEntry) + "?",
                    { my: "center", at: "center", of: window },
                    function () {
                        me.updateData({ TypeId: 4, Id: id }, function (result) {
                            if (!(result && result.Success)) {
                                me.myHtml.overview.css("opacity", 1);
                                return;
                            }
                            item.remove();
                            me.myHtml.overview.css("opacity", 1);
                            me.myHtml.overview.listData.find(".vc-list-item:even").removeClass("alt");
                            me.myHtml.overview.listData.find(".vc-list-item:odd").removeClass("alt");
                            me.myHtml.overview.listData.find(".vc-list-item:even").addClass("alt");

                            me._fetchOverview()
                        });
                    },
                    function () {
                        me.myHtml.overview.css("opacity", 1);
                        return true;
                    }
                );
            });


            me._initFrequencyDropdown();
            me._initHourDropdown();
            me._initReportTypeDropdown();
            me._initLanguageDropdown();
            me._initFileFormatDropdown();


        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _buildHtml: function () {
        /// <summary>
        /// This function builds the html structure
        /// </summary>
        var me = this;
        try {
            me.myHtml = { topmenu: {}, content: {}, overview: {}, editForm: {} };

            // ---- top menu ----
            me.myHtml.topmenu = me._setObj("div-ar-topmenu", "vc-grid-margin-bottom");
            let tmObj = me.myHtml.topmenu;
            tmObj.css({ width: "100%", boxSizing: "border-box" });

            tmObj.btnCustomXls = me._setObj("btn-ar-custom-xls", "button-toggle button-toggle-active").html("XLS - " + me.specific.resources.reports).css("width", "190px").button();
            tmObj.btnStandard = me._setObj("btn-ar-standard", "button-toggle").html(me.specific.resources.default + " - " + me.specific.resources.reports).css("width", "190px").button();
            tmObj.append(tmObj.btnCustomXls, tmObj.btnStandard);
            tmObj.append($("<hr>").css({ width: "100%", border: "none", borderTop: "1px solid #ccc", margin: "5px 0 2px 0" }));

            // ---- content wrapper (holds overview + editForm) ----
            me.myHtml.content = me._setObj("div-ar-content", "").css({ width: "100%" });

            // ---- overview ----
            me.myHtml.overview = me._setObj("div-overview", "").css("width", "100%");
            let obj = me.myHtml.overview;
            obj.btnNew = me._setObj("div-btn-new", "vc-grid-1col float-box").css("float", "right").html(me.specific.resources.new).button();
            obj.append(obj.btnNew);

            // warning shown directly in the overview when no reports are available for the current mode
            obj.divNoReports = $("<div>").attr("id", "div-ar-no-reports").addClass("note ar-note-warning").css({ clear: "both", "margin-top": "8px" }).text(me.specific.resources.ERR_noReportsAvailable).hide();
            obj.append(obj.divNoReports);

            // clearfix + spacer between button and list
            obj.clearfix = $("<div>").css({ clear: "both", height: "10px" });
            obj.append(obj.clearfix);

            // ---- overview list ----
            obj.listWrapper = me._setWrapper("div-overview-list", "vc-list").css({ "margin-top": "10px", clear: "both" });

            // header
            obj.listHeader = me._setListHeader("div-overview-header");
            var headerLine = me._setListItem();
            headerLine.column.append(me._setListElement("", "ar-col-active").html(me.specific.resources.active));
            headerLine.column.append(me._setListElement("", "ar-col-name").html(me.specific.resources.name));
            headerLine.column.append(me._setListElement("", "ar-col-description").html(me.specific.resources.description));
            headerLine.column.append(me._setListElement("", "ar-col-type").html(me.specific.resources.report));
            headerLine.column.append(me._setListElement("", "ar-col-recipients").html(me.specific.resources.recipients));
            headerLine.column.append(me._setListElement("", "ar-col-frequency").html(me.specific.resources.frequency));
            headerLine.column.append(me._setListElement("", "ar-col-creator").html(me.specific.resources.creator));
            headerLine.column.append(me._setListElement("", "ar-col-sending").html(""));
            headerLine.column.append(me._setListElement("", "ar-col-delete").html(""));
            obj.listHeader.append(headerLine.item);

            // data rows
            obj.listData = me._setObj("div-overview-data", "vc-list-table");

            obj.listWrapper.append(obj.listHeader, obj.listData);
            obj.append(obj.listWrapper);

            // edit form to create or edit auto report
            me.myHtml.editForm = me._setObj("div-edit-form", "").css("width", "100%");
            obj = me.myHtml.editForm;

            // ---- menu bar (back + save) ----
            obj.menu = me._setObj("div-edit-form-menu", "");
            obj.menu.css({ width: "100%", display: "grid", "grid-template-columns": "1fr auto", "align-items": "center", "margin-bottom": "15px" });
            obj.btnBack = me._setObj("div-btn-back", "button-toggle").html(me.specific.resources.back).css({ "width": "100px" }).button();
            obj.btnSave = me._setObj("div-btn-save", "button-toggle").html(me.specific.resources.save).css({ "width": "100px" }).button();
            obj.btnSave.button("disable"); // disabled until all fields are valid
            obj.menu.append(obj.btnBack, obj.btnSave);
            obj.append(obj.menu);

            // warning shown when no report options are available for the current mode
            obj.divNoReports = $("<div>").attr("id", "div-ar-no-reports").addClass("note ar-note-warning").text(me.specific.resources.ERR_noReportsAvailable).hide();
            obj.append(obj.divNoReports);

            // ---- edit area with 3 columns ----
            me.myHtml.editForm.editArea = {};
            let editArea = me.myHtml.editForm.editArea;
            editArea.wrapper = me._setObj("div-edit-area", "").css({ display: "flex", gap: "20px", "align-items": "flex-start" });

            // ---- left column: name, description, etc ----
            editArea.leftBox = {};
            let left = editArea.leftBox;
            left.wrapper = $("<fieldset>").attr("id", "div-left-box").addClass("formFieldset field1 vc-grid-margin-bottom");
            left.wrapper.append($("<legend>").text(me.specific.resources.report));


            // active + useNameAsEmailSubject checkboxes – two separate formItems in one row
            left.divChbRow = $("<div>").attr("id", "div-report-chb-row").css({ display: "flex", gap: "10px", marginBottom: "0" });

            // active checkbox
            left.divChbActive = me._setWrapper("div-report-chb-active", "formItem formItemValid type-check").css({ flex: "1 1 50%" });
            left.divActive = $("<div>").attr("id", "div-report-active").css({ display: "flex", gap: "10px", alignItems: "center", marginLeft: "3px", marginBottom: "5px", marginTop: "5px" });
            left.chbActive = $("<input>").attr({ type: "checkbox", id: "chb-report-active" }).prop("checked", true);
            left.lblActive = $("<label>").attr("for", "chb-report-active").text(me.specific.resources.active);
            left.divActive.append(left.chbActive, left.lblActive);
            left.divChbActive.append(left.divActive);

            // useNameAsEmailSubject checkbox
            left.divChbUseName = me._setWrapper("div-report-chb-usename", "formItem formItemValid type-check").css({ flex: "1 1 50%" });
            left.divUseName = $("<div>").attr("id", "div-report-usename").css({ display: "flex", gap: "10px", alignItems: "center", marginLeft: "3px", marginBottom: "5px", marginTop: "5px" });
            left.chbUseNameAsEmailSubject = $("<input>").attr({ type: "checkbox", id: "chb-report-usenamesubject" }).prop("checked", false);
            left.lblUseNameAsEmailSubject = $("<label>").attr("for", "chb-report-usenamesubject").text(me.specific.resources.useNameAsEmailSubject || "Name als E-Mail Betreff").css({ "font-weight": "normal", cursor: "pointer" });
            left.divUseName.append(left.chbUseNameAsEmailSubject, left.lblUseNameAsEmailSubject);
            left.divChbUseName.append(left.divUseName);

            left.divChbRow.append(left.divChbActive, left.divChbUseName);

            // name field
            left.divName = me._setWrapper("div-report-name", "formItem formItemInvalid type-text txtItem");
            left.captionName = me._setObj("", "caption").html(me.specific.resources.name);
            left.txtName = me._setInput("txt-report-name", "value large txtInput").attr("placeholder", me.specific.resources.reportName);
            left.divName.append(left.captionName, left.txtName);

            // description field
            left.divEditor = me._setObj("div-report-editor", "formItem formItemValid type-text"); //.css("margin-top", "10px");
            left.captionRow = me._setObj("div-report-desc-caption-row", "caption-row");
            left.captionDescription = me._setObj("", "caption").html(me.specific.resources.description);
            left.captionRow.append(left.captionDescription);
            left.divDescription = me._setObj("div-report-description", "value readonly");
            left.txtDescription = me._setTextArea("area-report-description", "value");
            left.divEditor.append(left.captionRow, left.divDescription, left.txtDescription);

            // filename field – only visible for standard reports
            left.divFileName = me._setWrapper("div-report-filename", "formItem formItemValid type-text txtItem").css({ /*"margin-top": "10px", */display: "none", "min-height": "130px" });
            left.captionFileName = me._setObj("", "caption").html((me.specific.resources.fileName || "Dateiname") +
                "<br><span style='font-size:0.72em; font-weight:normal;'>STARTDATE[dd.MM.yyyy] - Dieser Platzhalter wird durch das Startdatum (1. Tag) im angegebenen Format (dd.MM.yyyy) bei Berichtsgenerierung ersetzt.</span>" +
                "<br><span style='font-size:0.72em; font-weight:normal;'>ENDDATE[dd.MM.yyyy] - Dieser Platzhalter wird durch das Enddatum (letzter Tag) im angegebenen Format (dd.MM.yyyy) bei Berichtsgenerierung ersetzt.</span>"
            );
            left.txtFileName = me._setInput("txt-report-filename", "value large txtInput").attr("placeholder", "Dateiname");
            left.divFileName.append(left.captionFileName, left.txtFileName);

            left.wrapper.append(left.divChbRow, left.divName, left.divEditor, left.divFileName);

            // ---- middle column: sending details ----
            editArea.rightBox = {};
            let right = editArea.rightBox;
            right.wrapper = $("<fieldset>").attr("id", "div-right-box").addClass("formFieldset vc-grid-margin-bottom");
            right.wrapper.css({ display: "flex", "flex-direction": "column" });
            right.wrapper.append($("<legend>").text(me.specific.resources.mailing));


            right.divReportType = me._setWrapper("div-report-type", "formItem formItemValid type-select");
            right.captionReportType = me._setObj("", "caption").html(me.specific.resources.report);

            right.ddlXlsWrap = $("<div>").attr("id", "div-ddl-type-xls");
            right.ddlReportTypeXls = me._setObj("ddl-report-type-xls", "value edit");
            right.ddlXlsWrap.append(right.ddlReportTypeXls);

            right.ddlStdWrap = $("<div>").attr("id", "div-ddl-type-std");
            right.ddlReportTypeStd = me._setObj("ddl-report-type-std", "value edit");
            right.ddlStdWrap.append(right.ddlReportTypeStd);

            right.divReportType.append(right.captionReportType, right.ddlXlsWrap, right.ddlStdWrap);

            // recipients multi-select
            right.divRecipients = me._setWrapper("div-report-recipients", "formItem formItemInvalid type-select");
            right.captionRecipients = me._setObj("", "caption").html(me.specific.resources.recipients);
            right.ddlRecipients = me._setObj("ddl-report-recipients", "value edit");
            right.divRecipients.append(right.captionRecipients, right.ddlRecipients);

            // external recipients
            right.divEmails = me._setWrapper("div-report-emails", "formItem formItemValid type-text"); //.css("margin-top", "10px");
            right.captionEmails = me._setObj("", "caption").html(me.specific.resources.externalEmails);
            right.txtEmails = me._setInput("txt-report-emails", "value large txtInput").attr("placeholder", "email@example.com; email2@example.com");
            right.txtEmails.on("blur", function () {
                // on leave: normalize all separators (space, comma) to "; "
                var val = $(this).val().trim();
                if (val.length === 0) return;
                var parts = val.split(/[;,\s]+/).map(function (v) { return v.trim(); }).filter(function (v) { return v.length > 0; });
                $(this).val(parts.join("; "));
                me._dirty = true;
                me._validateEmails();
                me._updateSaveButtonStatus();
            });
            right.divEmails.append(right.captionEmails, right.txtEmails);

            // frequency + Hour
            right.divTopRow = $("<div>").attr("id", "div-report-top-row").css({ display: "flex", gap: "10px", "align-items": "flex-start", "flex-wrap": "nowrap"/*, "margin-top": "10px"*/ });

            // frequency dropdown
            right.divFrequency = me._setWrapper("div-report-frequency", "formItem formItemValid type-select");
            right.captionFrequency = me._setObj("", "caption").html(me.specific.resources.frequency);
            right.ddlFrequency = me._setObj("ddl-report-frequency", "value edit");
            right.divFrequency.append(right.captionFrequency, right.ddlFrequency);

            // Hour – Selectize dropdown 0-23
            right.divHour = me._setWrapper("div-report-hour", "formItem formItemValid type-select");
            right.captionHour = me._setObj("", "caption").html(me.specific.resources.time);
            right.ddlHour = me._setObj("ddl-report-hour", "value edit");
            right.divHour.append(right.captionHour, right.ddlHour);

            right.divTopRow.append(right.divFrequency, right.divHour);

            // extra-info panel 
            right.divExtraInfo = $("<div>").attr("id", "div-report-extrainfo").css({ display: "contents" });
            right.divTopRow.append(right.divExtraInfo);         

            // language + file format – one row, side by side
            right.divBottomRow = $("<div>").attr("id", "div-report-bottom-row").css({ display: "flex", gap: "10px", "align-items": "flex-start"/*, "margin-top": "10px" */});

            right.divLanguage = me._setWrapper("div-report-language", "formItem formItemValid type-select").css({ flex: "1 1 50%", minWidth: 0 });
            right.captionLanguage = me._setObj("", "caption").html(me.specific.resources.language);
            right.ddlLanguage = me._setObj("ddl-report-language", "value edit");
            right.divLanguage.append(right.captionLanguage, right.ddlLanguage);

            right.divFileFormat = me._setWrapper("div-report-fileformat", "formItem formItemValid type-select").css({ flex: "1 1 50%", minWidth: 0 });
            right.captionFileFormat = me._setObj("", "caption").html(me.specific.resources.filetype);
            right.ddlFileFormat = me._setObj("ddl-report-fileformat", "value edit");
            right.divFileFormat.append(right.captionFileFormat, right.ddlFileFormat);


            // add to media checkbox
            right.divAddToMedia = me._setWrapper("div-report-addtomedia", "formItem formItemValid type-check"); //.css("margin-top", "10px");
            right.divAddToMediaInner = $("<div>").attr("id", "div-report-addtomedia-inner").css({ display: "flex", gap: "10px", alignItems: "center", marginLeft: "3px", marginTop: "5px" });
            right.chbAddToMedia = $("<input>").attr({ type: "checkbox", id: "chb-report-addtomedia" }).prop("checked", false);
            right.lblAddToMedia = $("<label>").attr("for", "chb-report-addtomedia").text(me.specific.resources.addToMedia);
            right.divAddToMediaInner.append(right.chbAddToMedia, right.lblAddToMedia);
            right.divAddToMedia.append(right.divAddToMediaInner);

            right.divBottomRow.append(right.divLanguage, right.divFileFormat);
            right.wrapper.append(right.divReportType, right.divTopRow, right.divBottomRow, right.divRecipients, right.divEmails, right.divAddToMedia);

            // ---- signal box: only visible in standard mode ----
            editArea.signalBox = {};
            var sig = editArea.signalBox;
            sig.wrapper = $("<fieldset>").attr("id", "div-signal-box").addClass("formFieldset vc-grid-margin-bottom");
            sig.wrapper.css({ display: "flex", "flex-direction": "column","box-sizing": "border-box" });
            sig.wrapper.append($("<legend>").text(me.specific.resources.signalSelection));

            // "Alle Signale" checkbox – when checked, bsaids = [-1] is sent
            sig.divAllSignals = $("<div>").attr("id", "div-signal-all").css({ display: "flex", gap: "6px", alignItems: "center", padding: "3px 4px 6px 4px", "border-bottom": "1px solid #ddd", "margin-bottom": "6px" });
            sig.chbAllSignals = $("<input>").attr({ type: "checkbox", id: "chb-sig-all" }).prop("checked", true);
            sig.lblAllSignals = $("<label>").attr("for", "chb-sig-all").text(me.specific.resources.showAll || "Alle Signale").css({ cursor: "pointer", "font-weight": "normal" });
            sig.divAllSignals.append(sig.chbAllSignals, sig.lblAllSignals);

            sig.divFilter = $("<div>").attr("id", "div-signal-filter").addClass("formItem formItemValid type-text").css("margin-bottom", "6px");
            sig.txtFilter = me._setInput("txt-signal-filter", "value large txtInput").attr("placeholder", me.specific.resources.filter || "Filter...");
            sig.divFilter.append(sig.txtFilter);

            sig.divList = $("<div>").attr("id", "div-signal-list").css({ "overflow-y": "auto", "overflow-x": "hidden", "border": "1px solid #ddd", "padding": "4px", width: "100%", "box-sizing": "border-box" });

            sig.wrapper.append(sig.divAllSignals, sig.divFilter, sig.divList);
            sig.wrapper.hide();

            // ---- manual execution box: only visible for admins in standard mode ----
            editArea.manualBox = {};
            var manual = editArea.manualBox;
            manual.wrapper = $("<fieldset>").attr("id", "div-manual-box").addClass("formFieldset vc-grid-margin-bottom");
            manual.wrapper.css({ "box-sizing": "border-box" });
            manual.wrapper.append($("<legend>").text(me.specific.resources.manualExecution || "Manuelle Ausführung"));

            manual.divInfo = $("<div>").attr("id", "div-manual-info").addClass("note ar-note-info").css({ marginBottom: "10px" }).text('Wählen Sie den gewünschten Ausführungszeitpunkt aus und klicken Sie auf "Senden". Die Ausführung kann bis zu 30sec dauern.');

            // --- Date formItem: Day (interval 1) – shown by default ---
            manual.divDateDay = me._setObj("div-manual-date-day", "formItem formItemValid type-date");
            manual.captionDay = me._setObj("", "caption").html(me.specific.resources.date || "Datum");
            manual.calDay = me._setObj("div-manual-cal-day", "value edit").css("margin-left", "20px");
            manual.divDateDay.append(manual.captionDay, manual.calDay);

            // --- Date formItem: Month (interval 3) – hidden ---
            manual.divDateMonth = me._setObj("div-manual-date-month", "formItem formItemValid type-date").hide();
            manual.captionMonth = me._setObj("", "caption").html(me.specific.resources.month || "Monat");
            manual.calMonth = me._setObj("div-manual-cal-month", "value edit").css("margin-left", "20px");
            manual.divDateMonth.append(manual.captionMonth, manual.calMonth);

            // --- Date formItem: Year (interval 5) – hidden ---
            manual.divDateYear = me._setObj("div-manual-date-year", "formItem formItemValid type-date").hide();
            manual.captionYear = me._setObj("", "caption").html(me.specific.resources.year || "Jahr");
            manual.calYear = me._setObj("div-manual-cal-year", "value edit").css("margin-left", "20px");
            manual.divDateYear.append(manual.captionYear, manual.calYear);

            // --- Send button ---
            manual.divSend = $("<div>").attr("id", "div-manual-send").css({ "margin-top": "10px" });
            manual.btnSend = me._setObj("btn-manual-send", "button-toggle").html(me.specific.resources.send || "Senden").css({ width: "100%" }).button().button("disable");
            manual.divSend.append(manual.btnSend);

            manual.wrapper.append(manual.divInfo, manual.divDateDay, manual.divDateMonth, manual.divDateYear, manual.divSend);
            manual.wrapper.hide();

            editArea.wrapper.append(left.wrapper, right.wrapper, sig.wrapper, manual.wrapper);

            obj.append(editArea.wrapper);

            me.myHtml.editForm.hide();

            // assemble
            me.myHtml.content.append(me.myHtml.overview, me.myHtml.editForm);
            me.myRoot.append(me.myHtml.topmenu, me.myHtml.content);


        } catch (e) { me._writeErr(e); return false; }
    },

    _setHeightsWidths: function () {
        var me = this;
        try {
            var hWidget = me.myRoot.height();
            var hTopmenu = me.myHtml.topmenu.outerHeight(true) || 0;
            var hContent = hWidget - hTopmenu - 4;
            me.myHtml.content.css("height", hContent + "px");

            var hBox = me.fnd("#div-left-box").height();
            me.fnd("#div-right-box").height(hBox);

            // signal box: same total height as left/right box; list fills remaining space
            var sigBox = me.fnd("#div-signal-box");
            if (sigBox.is(":visible")) {
                sigBox.height(hBox);
                var hFilter = me.fnd("#div-signal-filter").outerHeight(true) || 0;
                var hLegend = sigBox.find("legend").outerHeight(true) || 0;
                var hPadding = parseInt(sigBox.css("padding-top") || 0, 10)
                    + parseInt(sigBox.css("padding-bottom") || 0, 10) + 4;
                me.fnd("#div-signal-list").height(hBox - hFilter - hLegend - hPadding);
            }
        } catch (e) { me._writeErr(e); return false; }
    },

    _save: function () {
        var me = this;
        try {
            var left = me.myHtml.editForm.editArea.leftBox;
            var right = me.myHtml.editForm.editArea.rightBox;
            var isActive = left.chbActive.prop("checked");

            var sz = right.ddlRecipients && right.ddlRecipients[0] && right.ddlRecipients[0].selectize;
            var uid = sz ? sz.items.map(function (v) { return parseInt(v, 10); }) : [];

            var freqId = parseInt(me.ddlFrequency.getValue(), 10);
            var hour = me.ddlHour ? parseInt(me.ddlHour.getValue(), 10) : 0;

            // field names must match Data.Frequency.Entry (PascalCase, FrequencyType not frequencyId)
            var frequency = { FrequencyType: freqId, Hour: hour, Minutes: [0] };

            if (freqId === 2 && me.scheduleExtra.weekday) frequency.WeekDay = me.scheduleExtra.weekday;
            if (freqId === 3 && me.scheduleExtra.dayOfMonth) frequency.DayOfMonth = me.scheduleExtra.dayOfMonth;
            if (freqId === 4) {
                if (me.scheduleExtra.quarterMonth) frequency.QuarterMonth = me.scheduleExtra.quarterMonth;
                if (me.scheduleExtra.quarterDay) frequency.DayOfMonth = me.scheduleExtra.quarterDay;
            }
            if (freqId === 5) {
                if (me.scheduleExtra.yearlyMonth) frequency.Month = me.scheduleExtra.yearlyMonth;
                if (me.scheduleExtra.yearlyDay) frequency.DayOfMonth = me.scheduleExtra.yearlyDay;
            }

            me.myHtml.editForm.btnSave.button("disable");

            var isStandard = me.myStatus.selectedReportMode === "standard";
            var reportTypeId = isStandard ? 2 : 1;                          // int, not array!
            var reportId = me.ddlReportType ? parseInt(me.ddlReportType.getValue(), 10) : 1;
            var fileFormat = isStandard ? "xls" : (me.ddlFileFormat ? me.ddlFileFormat.getValue() || "xls" : "xls");
            var isEdit = !!(me._currentEditId && me._currentEditId > 0);
            var emails = right.txtEmails.val().trim();
            var langId = me.ddlLanguage ? parseInt(me.ddlLanguage.getValue(), 10) : (me.specific.userLangID || 2);
            var addToMedia = right.chbAddToMedia ? right.chbAddToMedia.prop("checked") : false;
            var fileName = (isStandard && left.txtFileName) ? left.txtFileName.val().trim() : "";
            var useNameAsEmailSubject = left.chbUseNameAsEmailSubject ? left.chbUseNameAsEmailSubject.prop("checked") : false;

            // flat structure matching AutoReportRequest directly
            var param = {
                TypeId: isEdit ? 2 : 1,
                Id: isEdit ? me._currentEditId : -1,
                Active: isActive,
                Name: left.txtName.val().trim(),
                Description: me.reportDescriptionText || "",
                UserIds: uid,
                Emails: emails,
                Frequency: frequency,
                ReportTypeId: reportTypeId,
                ReportId: reportId,
                LangId: langId,
                Filetype: fileFormat,
                AddToMedia: addToMedia,
                Bsaids: isStandard ? me._getSelectedBsaids() : [],
                FileName: fileName,
                UseNameAsEmailSubject: useNameAsEmailSubject,
                Date: ""
            };

            me.updateData(param, function (result) {
                if (!result.Success) {
                    me._dirty = true;
                    me.myHtml.editForm.btnSave.button("enable");
                    return;
                }
                if (result.Id && result.Id > 0) {
                    me._currentEditId = result.Id;
                    if (!me._currentManualExeSent) {
                        me.myHtml.editForm.editArea.manualBox.btnSend.button("enable");
                    }
                }
            });

        } catch (e) { me._writeErr(e); }
    },

    // =====================================================================
    // VALIDATION
    // =====================================================================

    _validate: function () {
        var me = this;
        try {
            var ok = true;
            if (!me._validateName()) ok = false;
            if (!me._validateReportType()) ok = false;
            if (!me._validateRecipients()) ok = false;
            if (!me._validateHour()) ok = false;
            if (!me._validateEmails()) ok = false;
            if (!me._validateSignalSelection()) ok = false;
            me._updateSaveButtonStatus();
            return ok;
        } catch (e) { me._writeErr(e); return false; }
    },

    _validateName: function () {
        /// <summary>
        /// Checks that the report name is not empty
        /// </summary>
        var me = this;
        try {
            var left = me.myHtml.editForm.editArea.leftBox;
            var val  = String(left.txtName.val() || "").trim();
            if (val.length === 0) {
                me._setInvalid(left.divName, me.specific.resources.ERR_inputInvalid);
                return false;
            }
            me._setValid(left.divName);
            return true;
        } catch (e) { me._writeErr(e); return false; }
    },

    _validateDescription: function () {
        /// <summary>
        /// Checks that the description is not empty (strips HTML before checking).
        /// </summary>
        var me = this;
        try {
            var left = me.myHtml.editForm.editArea.leftBox;
            var raw  = me.reportDescriptionText || "";
            // strip HTML tags to get plain text
            var tmp  = document.createElement("div");
            tmp.innerHTML = raw;
            var plain = (tmp.textContent || tmp.innerText || "").trim();

            if (plain.length === 0) {
                me._setInvalid(left.divEditor, me.specific.resources.ERR_inputInvalid);
                return false;
            }
            me._setValid(left.divEditor);
            return true;
        } catch (e) { me._writeErr(e); return false; }
    },

    _validateHour: function () {
        /// <summary>
        /// Checks that a valid hour (0–23) is selected in the dropdown.
        /// </summary>
        var me = this;
        try {
            var right = me.myHtml.editForm.editArea.rightBox;
            var val = me.ddlHour ? parseInt(me.ddlHour.getValue(), 10) : NaN;
            if (isNaN(val) || val < 0 || val > 23) {
                me._setInvalid(right.divHour, me.specific.resources.ERR_inputInvalid);
                return false;
            }
            me._setValid(right.divHour);
            return true;
        } catch (e) { me._writeErr(e); return false; }
    },

    _validateRecipients: function () {
        ///
        /// Checks that at least one recipient is selected.
        /// </summary>
        var me = this;
        try {
            var right = me.myHtml.editForm.editArea.rightBox;

            var sz = right.ddlRecipients && right.ddlRecipients[0] && right.ddlRecipients[0].selectize;
            var count = sz ? sz.items.length : (me.selectedRecipients ? me.selectedRecipients.length : 0);
            var ok = count > 0;

            if (ok) {
                me._setValid(right.divRecipients);
            } else {
                me._setInvalid(right.divRecipients, me.specific.resources.ERR_inputInvalid);
            }
            return ok;
        } catch (e) { me._writeErr(e); return false; }
    },

    _validateReportType: function () {
        /// <summary>
        /// Checks that a report type is selected (DDL not empty).
        /// </summary>
        var me = this;
        try {
            var right = me.myHtml.editForm.editArea.rightBox;
            var val = me.ddlReportType ? parseInt(me.ddlReportType.getValue(), 10) : 0;
            var ok = !isNaN(val) && val > 0;
            if (ok) {
                me._setValid(right.divReportType);
            } else {
                me._setInvalid(right.divReportType, me.specific.resources.ERR_inputInvalid);
            }
            return ok;
        } catch (e) { me._writeErr(e); return false; }
    },

    _updateSaveButtonStatus: function () {
        /// <summary>
        /// Enables or disables the Save button based on visible invalid fields and dirty state.
        /// </summary>
        var me = this;
        try {
            var editForm = me.myHtml.editForm;
            if (!editForm || !editForm.btnSave) return;

            var anyInvalid = editForm.find(".formItemInvalid:visible").length > 0;
            var btn = editForm.btnSave;

            if (anyInvalid || !me._dirty) {
                btn.button("disable");
            } else {
                btn.button("enable");
            }
        } catch (e) { me._writeErr(e); }
    },

    _setValid: function (wrap) {
        /// <summary>
        /// Marks a formItem as valid (green check icon).
        /// </summary>
        if (!wrap || !wrap.length) return;
        wrap.removeClass("formItemInvalid").addClass("formItemValid");
        this._setValidationIcon(wrap, true, "");
    },

    _setInvalid: function (wrap, title) {
        /// <summary>
        /// Marks a formItem as invalid (red border + error icon).
        /// </summary>
        if (!wrap || !wrap.length) return;
        wrap.removeClass("formItemValid").addClass("formItemInvalid");
        this._setValidationIcon(wrap, false, title || "");
    },

    _setNeutral: function (wrap) {
        /// <summary>
        /// Removes valid / invalid state from a formItem.
        /// </summary>
        if (!wrap || !wrap.length) return;
        wrap.removeClass("formItemValid formItemInvalid");
        wrap.find(".ar-validation-icon").empty().attr("title", "");
    },

    _setValidationIcon: function (wrap, ok, title) {
        /// <summary>
        /// Inserts or updates the validation icon inside the caption of a formItem.
        /// </summary>
        var id = "ar-vi-" + (wrap.attr("id") || Math.random().toString(36).slice(2));
        var spot = wrap.find("#" + id);
        if (spot.length === 0) {
            spot = $("<span>").attr("id", id).addClass("ar-validation-icon").css({ float: "right", "margin-top": "2px" });
            var cap = wrap.find(".caption").first();
            if (cap.length) cap.append(spot); else wrap.append(spot);
        }
        spot.attr("title", title || "");
        spot.html(ok ? "<i class='fa fa-check icon-color-ok'></i>" : "<i class='fa-regular fa-times-circle icon-color-error'></i>"
        );
    },

    _normalizeTime: function (t) {
        /// <summary>
        /// Tries to parse and normalize a time string into HH format.
        /// </summary>
        if (!t) return null;
        t = String(t).trim();

        var m = /^([0-1]?\d|2[0-3]):([0-5]\d)$/.exec(t);
        if (m) return m[1].padStart(2, "0") + ":" + m[2];

        var digits = t.replace(/\D/g, "");
        if (!digits.length) return null;

        if (digits.length === 1) return "0" + digits + ":00";
        if (digits.length === 2) {
            var hh = parseInt(digits, 10);
            return hh > 23 ? null : String(hh).padStart(2, "0") + ":00";
        }
        if (digits.length === 3) {
            var h3 = parseInt(digits[0], 10), m3 = parseInt(digits.slice(1), 10);
            return (h3 > 23 || m3 > 59) ? null : String(h3).padStart(2, "0") + ":" + String(m3).padStart(2, "0");
        }
        if (digits.length === 4) {
            var h4 = parseInt(digits.slice(0, 2), 10), m4 = parseInt(digits.slice(2), 10);
            return (h4 > 23 || m4 > 59) ? null : String(h4).padStart(2, "0") + ":" + String(m4).padStart(2, "0");
        }
        return null;
    },

    // =====================================================================
    // FREQUENCY / SCHEDULE
    // =====================================================================

    _initFrequencyDropdown: function () {
        /// <summary>
        /// Initializes the frequency Selectize dropdown and the dynamic extra-info panel.
        /// </summary>
        var me = this;
        try {
            const right = me.myHtml.editForm.editArea.rightBox;

            const frequencyOptions = [
                { Id: 1, Name: me.specific.resources.daily },
                { Id: 2, Name: me.specific.resources.weekly },
                { Id: 3, Name: me.specific.resources.monthly },
                { Id: 4, Name: me.specific.resources.quarterly },
                { Id: 5, Name: me.specific.resources.yearly }
            ];

            right.ddlFrequency.selectize({
                create: false,
                maxItems: 1,
                valueField: "Id",
                labelField: "Name",
                searchField: "Name",
                options: frequencyOptions,
                dropdownParent: "body",
                onChange: function (value) {
                    if (!me._resetting) {
                        me._dirty = true;
                        me._updateSaveButtonStatus();
                    }
                    me._renderExtraInfo(parseInt(value, 10));
                }
            });

            me.ddlFrequency = right.ddlFrequency[0].selectize;
            me.ddlFrequency.setValue(1, true);
            me._renderExtraInfo(1);

        } catch (e) { me._writeErr(e); }
    },

    _renderExtraInfo: function (frequencyId) {
        /// <summary>
        /// Renders the additional inputs below send-time depending on the selected frequency.
        /// </summary>
        var me = this;
        try {
            const container = me.myHtml.editForm.editArea.rightBox.divExtraInfo;
            container.empty();
            me.scheduleExtra = {};

            const makeWrap = function (id) {
                return me._setWrapper(id, "formItem formItemValid type-select ar-extra-item");
            };

            switch (frequencyId) {
                case 1: return; // daily has no extra options

                case 2: { // weekly
                    const wrap = makeWrap("div-report-extra-weekday");
                    const caption = me._setObj("", "caption").html(me.specific.resources.day);
                    const select = me._setObj("ddl-report-weekday", "value edit");
                    wrap.append(caption, select);
                    container.append(wrap);

                    const weekdays = [
                        { Id: 1, Name: me.specific.resources.monday },
                        { Id: 2, Name: me.specific.resources.tuesday },
                        { Id: 3, Name: me.specific.resources.wednesday },
                        { Id: 4, Name: me.specific.resources.thursday },
                        { Id: 5, Name: me.specific.resources.friday },
                        { Id: 6, Name: me.specific.resources.saturday },
                        { Id: 7, Name: me.specific.resources.sunday }
                    ];

                    select.selectize({
                        create: false, maxItems: 1, valueField: "Id", labelField: "Name",
                        searchField: "Name", options: weekdays, dropdownParent: "body",
                        onChange: function (v) { me.scheduleExtra.weekday = parseInt(v, 10); if (!me._resetting) { me._dirty = true; me._updateSaveButtonStatus(); } }
                    });
                    select[0].selectize.setValue(1, true);
                    me.scheduleExtra.weekday = 1;
                    break;
                }

                case 3: { // monthly
                    const wrap = makeWrap("div-report-extra-dayofmonth");
                    const caption = me._setObj("", "caption").html(me.specific.resources.day);
                    const select = me._setObj("ddl-report-dayofmonth", "value edit");
                    wrap.append(caption, select);
                    container.append(wrap);

                    const days = [
                        { Id: 1, Name: "1." }, { Id: 2, Name: "2." }, { Id: 3, Name: "3." }, { Id: 4, Name: "4." }, { Id: 5, Name: "5." },
                        { Id: 6, Name: "6." }, { Id: 7, Name: "7." }, { Id: 8, Name: "8." }, { Id: 9, Name: "9." }, { Id: 10, Name: "10." },
                        { Id: 11, Name: "11." }, { Id: 12, Name: "12." }, { Id: 13, Name: "13." }, { Id: 14, Name: "14." }, { Id: 15, Name: "15." },
                        { Id: 16, Name: "16." }, { Id: 17, Name: "17." }, { Id: 18, Name: "18." }, { Id: 19, Name: "19." }, { Id: 20, Name: "20." },
                        { Id: 21, Name: "21." }, { Id: 22, Name: "22." }, { Id: 23, Name: "23." }, { Id: 24, Name: "24." }, { Id: 25, Name: "25." },
                        { Id: 26, Name: "26." }, { Id: 27, Name: "27." }, { Id: 28, Name: "28." }, { Id: 29, Name: "29." }, { Id: 30, Name: "30." },
                        { Id: 31, Name: "31." }
                    ];
                    select.selectize({
                        create: false, maxItems: 1, valueField: "Id", labelField: "Name",
                        searchField: "Name", options: days, dropdownParent: "body",
                        onChange: function (v) { me.scheduleExtra.dayOfMonth = parseInt(v, 10); if (!me._resetting) { me._dirty = true; me._updateSaveButtonStatus(); } }
                    });
                    select[0].selectize.setValue(1, true);
                    me.scheduleExtra.dayOfMonth = 1;
                    break;
                }

                case 4: { // quarterly
                    const wrapMonth = makeWrap("div-report-extra-qmonth");
                    const captionMonth = me._setObj("", "caption").html(me.specific.resources.month);
                    const selectMonth = me._setObj("ddl-report-qmonth", "value edit");
                    wrapMonth.append(captionMonth, selectMonth);
                    container.append(wrapMonth);

                    const qMonths = [
                        { Id: 1, Name: me.specific.resources.quarterMonth1 || "1. Monat" },
                        { Id: 2, Name: me.specific.resources.quarterMonth2 || "2. Monat" },
                        { Id: 3, Name: me.specific.resources.quarterMonth3 || "3. Monat" }
                    ];

                    const wrapDay = makeWrap("div-report-extra-qday");
                    const captionDay = me._setObj("", "caption").html(me.specific.resources.day);
                    const selectDay = me._setObj("ddl-report-qday", "value edit");
                    wrapDay.append(captionDay, selectDay);
                    container.append(wrapDay);

                    const maxDaysForQMonth = [31, 28, 31];
                    const rebuildQDays = function (qMonth, currentDay) {
                        const sz = selectDay[0].selectize;
                        if (!sz) return;
                        const prevVal = currentDay || parseInt(sz.getValue(), 10) || 1;
                        sz.clearOptions();
                        sz.load(function (cb) {
                            cb(Array.from({ length: maxDaysForQMonth[qMonth - 1] }, function (_, i) {
                                return { Id: i + 1, Name: (i + 1) + "." };
                            }));
                        });
                        sz.setValue(Math.min(prevVal, maxDaysForQMonth[qMonth - 1]), true);
                        me.scheduleExtra.quarterDay = Math.min(prevVal, maxDaysForQMonth[qMonth - 1]);
                    };

                    selectDay.selectize({
                        create: false, maxItems: 1, valueField: "Id", labelField: "Name",
                        searchField: "Name", options: [], dropdownParent: "body",
                        onChange: function (v) { me.scheduleExtra.quarterDay = parseInt(v, 10); if (!me._resetting) { me._dirty = true; me._updateSaveButtonStatus(); } }
                    });
                    selectMonth.selectize({
                        create: false, maxItems: 1, valueField: "Id", labelField: "Name",
                        searchField: "Name", options: qMonths, dropdownParent: "body",
                        onChange: function (v) {
                            const qm = parseInt(v, 10);
                            me.scheduleExtra.quarterMonth = qm;
                            if (!me._resetting) { me._dirty = true; me._updateSaveButtonStatus(); }
                            rebuildQDays(qm);                            
                        }
                    });
                    selectMonth[0].selectize.setValue(1, true);
                    me.scheduleExtra.quarterMonth = 1;
                    rebuildQDays(1, 1);
                    break;
                }

                case 5: { // yearly
                    const months = [
                        { Id: 1, Name: me.specific.resources.january, days: 31 },
                        { Id: 2, Name: me.specific.resources.february, days: 28 },
                        { Id: 3, Name: me.specific.resources.march, days: 31 },
                        { Id: 4, Name: me.specific.resources.april, days: 30 },
                        { Id: 5, Name: me.specific.resources.may, days: 31 },
                        { Id: 6, Name: me.specific.resources.june, days: 30 },
                        { Id: 7, Name: me.specific.resources.july, days: 31 },
                        { Id: 8, Name: me.specific.resources.august, days: 31 },
                        { Id: 9, Name: me.specific.resources.september, days: 30 },
                        { Id: 10, Name: me.specific.resources.october, days: 31 },
                        { Id: 11, Name: me.specific.resources.november, days: 30 },
                        { Id: 12, Name: me.specific.resources.december, days: 31 }
                    ];

                    const wrapMonth = makeWrap("div-report-extra-ymonth");
                    const captionMonth = me._setObj("", "caption").html(me.specific.resources.month);
                    const selectMonth = me._setObj("ddl-report-yearly-month", "value edit");
                    wrapMonth.append(captionMonth, selectMonth);
                    container.append(wrapMonth);

                    const wrapDay = makeWrap("div-report-extra-yday");
                    const captionDay = me._setObj("", "caption").html(me.specific.resources.day);
                    const selectDay = me._setObj("ddl-report-yearly-day", "value edit");
                    wrapDay.append(captionDay, selectDay);
                    container.append(wrapDay);

                    const rebuildDays = function (monthId, keepDay) {
                        const monthObj = months.find(function (m) { return m.Id === monthId; });
                        const maxDay = monthObj ? monthObj.days : 28;
                        const sz = selectDay[0].selectize;
                        if (!sz) return;
                        const prevVal = keepDay || parseInt(sz.getValue(), 10) || 1;
                        sz.clearOptions();
                        sz.load(function (cb) {
                            cb(Array.from({ length: maxDay }, function (_, i) {
                                return { Id: i + 1, Name: (i + 1) + "." };
                            }));
                        });
                        sz.setValue(Math.min(prevVal, maxDay), true);
                        me.scheduleExtra.yearlyDay = Math.min(prevVal, maxDay);
                    };

                    selectDay.selectize({
                        create: false, maxItems: 1, valueField: "Id", labelField: "Name",
                        searchField: "Name", options: [], dropdownParent: "body",
                        onChange: function (v) { me.scheduleExtra.yearlyDay = parseInt(v, 10); if (!me._resetting) { me._dirty = true; me._updateSaveButtonStatus(); } }
                    });
                    selectMonth.selectize({
                        create: false, maxItems: 1, valueField: "Id", labelField: "Name",
                        searchField: "Name", options: months, dropdownParent: "body",
                        onChange: function (v) {
                            const mid = parseInt(v, 10);
                            me.scheduleExtra.yearlyMonth = mid;
                            if (!me._resetting) { me._dirty = true; me._updateSaveButtonStatus(); }
                            rebuildDays(mid);
                        }
                    });
                    selectMonth[0].selectize.setValue(1, true);
                    me.scheduleExtra.yearlyMonth = 1;
                    rebuildDays(1, 1);
                    break;
                }

                default: break;
            }

        } catch (e) { me._writeErr(e); }
    },

    // =====================================================================
    // EDITOR / DROPDOWNS
    // =====================================================================

    _initTextEditor: function () {
        /// <summary>
        /// Initializes the CLEditor for the report description textarea.
        /// Must be called when the edit form is visible so width() returns a correct value.
        /// </summary>
        var me = this;
        try {
            var w = me.myHtml.editForm.editArea.leftBox.divEditor.width() - 10;
            if (!w || w <= 0) w = 350;
            var h = 300;

            me.reportDescriptionEditor = me.myHtml.editForm.editArea.leftBox.txtDescription.cleditor({
                height: h,
                width: w,
                updateTextArea: function (html) {
                    if (!me._resetting) me._dirty = true;
                    var cleanedHtml = html.replace(/\n/g, "<br />");
                    me.reportDescriptionText = cleanedHtml;
                    me.myHtml.editForm.editArea.leftBox.txtDescription.val(cleanedHtml).blur();
                    me._updateSaveButtonStatus();
                },
                controls: 'bold italic underline | removeformat | bullets numbering'
            })[0];

            me.reportDescriptionEditor.refresh();

            const descBox = me.myHtml.editForm.editArea.leftBox;
            if (descBox && descBox.divDescription) {
                descBox.divDescription.hide();
            }
        } catch (e) { me._writeErr(e); }
    },

    _initUserDropdown: function () {
        /// <summary>
        /// Loads users via getData and initializes a Selectize multi-select dropdown for recipients.
        /// </summary>
        var me = this;
        try {
            me.getData({ TypeId: 1 }, function (result) {
                if (!result || !Array.isArray(result.rows)) return;

                const ddlEl = me.myHtml.editForm.editArea.rightBox.ddlRecipients;

                if (ddlEl[0] && ddlEl[0].selectize) {
                    ddlEl[0].selectize.destroy();
                }

                const items = result.rows.map(function (r) {
                    return { Id: r.id, Name: r.name };
                });

                ddlEl.selectize({
                    create: false,
                    maxItems: null,
                    valueField: "Id",
                    labelField: "Name",
                    searchField: "Name",
                    options: items,
                    plugins: ["remove_button"],
                    dropdownParent: "body",
                    placeholder: me.specific.resources.selectRecipients,
                    render: {
                        option: function (item, escape) {
                            return "<div class='option'>" + escape(item.Name) + "</div>";
                        }
                    },
                    onChange: function (values) {
                        me._dirty = true;
                        me.selectedRecipients = Array.isArray(values) ? values : (values ? [values] : []);
                        me._validateRecipients();
                        me._updateSaveButtonStatus();
                    }
                });

                me.ddlRecipients = ddlEl[0].selectize;

                // set initial invalid state (nothing selected yet)
                me._validateRecipients();
                me._updateSaveButtonStatus();
            });
        } catch (e) { me._writeErr(e); }
    },

    _initReportTypeDropdown: function () {
        /// <summary>
        /// Initializes two report type dropdowns – one for customXls (loaded dynamically), one for standard (loaded dynamically).
        /// Visibility is toggled via _updateReportTypeOptions.
        /// </summary>
        var me = this;
        try {
            var right = me.myHtml.editForm.editArea.rightBox;

            // XLS DDL – options loaded dynamically from server (reporting.report)
            right.ddlReportTypeXls.selectize({
                create: false, maxItems: 1, valueField: "Id", labelField: "Name", searchField: "Name",
                dropdownParent: "body", options: [],
                onChange: function (value) {
                    if (!me._resetting) {
                        me._dirty = true;
                        me._validateReportType();
                        me._updateSaveButtonStatus();
                    }

                    // pre-fill recipients from the stored Uids on the selected option
                    if (value && !me._resetting) {
                        var opt = me.ddlReportTypeXls.options[value];
                        if (opt && Array.isArray(opt.Uids)) {
                            me._prefillRecipientsFromUids(opt.Uids);
                        }
                    }
                }
            });

            me.ddlReportTypeXls = right.ddlReportTypeXls[0].selectize;

            // load XLS reports from server
            me.getData({ TypeId: 4 }, function (result) {
                if (!result || !Array.isArray(result.rows)) return;
                var items = result.rows.map(function (r) {
                    var uids = [];
                    if (r.reportuids && typeof r.reportuids === "string" && r.reportuids.length > 2) {
                        uids = r.reportuids.replace(/[{}]/g, "").split(",").map(function (v) { return parseInt(v.trim(), 10); }).filter(function (v) { return !isNaN(v); });
                    } else if (Array.isArray(r.reportuids)) {
                        uids = r.reportuids.map(function (v) { return parseInt(v, 10); }).filter(function (v) { return !isNaN(v); });
                    }
                    return { Id: r.reportid, Name: r.reportname, Uids: uids };
                });
                me._resetting = true;
                me.ddlReportTypeXls.addOption(items);
                if (items.length > 0) me.ddlReportTypeXls.setValue(items[0].Id, true);
                me._resetting = false;
                me._updateNoReportsWarning();
            });

            // Standard DDL – options loaded dynamically from server (getStandardReports)
            right.ddlReportTypeStd.selectize({
                create: false, maxItems: 1, valueField: "Id", labelField: "Name", searchField: "Name",
                dropdownParent: "body", options: [],
                onChange: function (value) {
                    if (!me._resetting) { me._dirty = true; me._validateReportType(); me._updateSaveButtonStatus(); }
                    me._checkHideAddMedia();
                    me._updateManualDateBox(value);
                }
            });

            me.ddlReportTypeStd = right.ddlReportTypeStd[0].selectize;

            // load standard reports from server
            me.getData({ TypeId: 5 }, function (result) {
                var items = Array.isArray(result) ? result : (result && Array.isArray(result.rows) ? result.rows : []);
                if (!items.length) { me._updateNoReportsWarning(); return; }
                items = items.map(function (r) {
                    return { Id: r.Id, Name: r.Name, HideAddMedia: !!r.HideAddMedia, Interval: r.Interval };
                }).sort(function (a, b) { return a.Id - b.Id; });
                me._resetting = true;
                me.ddlReportTypeStd.addOption(items);
                if (items.length > 0) me.ddlReportTypeStd.setValue(items[0].Id, true);
                me._resetting = false;
                me._updateNoReportsWarning();
                me._checkHideAddMedia();
            });

            // apply initial visibility
            me._updateReportTypeOptions(me.myStatus.selectedReportMode);

        } catch (e) { me._writeErr(e); }
    },

    _initLanguageDropdown: function () {
        /// <summary>
        /// Initializes the language Selectize dropdown with the available languages from server resources.
        /// </summary>
        var me = this;
        try {
            var right = me.myHtml.editForm.editArea.rightBox;
            if (!right || !right.ddlLanguage) return;

            var langs = me.specific.languages || [];
            var items = langs.map(function (l) { return { Id: l.Id, Name: l.Name }; });

            right.ddlLanguage.selectize({
                create: false,
                maxItems: 1,
                valueField: "Id",
                labelField: "Name",
                searchField: "Name",
                options: items,
                dropdownParent: "body",
                onChange: function () {
                    if (!me._resetting) { me._dirty = true; me._updateSaveButtonStatus(); }
                }
            });

            me.ddlLanguage = right.ddlLanguage[0].selectize;

            // default: current user language
            me._resetting = true;
            me.ddlLanguage.setValue(me.specific.userLangID || 2, true);
            me._resetting = false;

        } catch (e) { me._writeErr(e); }
    },

    // =====================================================================
    // OVERVIEW LIST
    // =====================================================================

    _fetchOverview: function () {
        /// <summary>
        /// Fetches all AutoReports from the server and renders the overview list.
        /// Filters by report type based on the currently selected top menu mode.
        /// customXls = typeid 1, standard = typeid 2
        /// </summary>
        var me = this;
        try {
            var reportTypeFilter = me.myStatus.selectedReportMode === "standard" ? 2 : 1;
            me.myHtml.overview.listData.html(me.getLoadingIcon());

            me.getData({ TypeId: 2, ReportTypeFilter: reportTypeFilter }, function (result) {
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    me.myHtml.topmenu.hide();
                    me.myHtml.overview.hide();
                    return;
                }
                if (!Array.isArray(result) || !result.length) {
                    me.myHtml.overview.listData.html($("<div>").addClass("note").text(me.resources.noEntriesExist));
                    me._updateTopMenuCount(0);
                    return;
                }
                me._generateOverviewList(result);
                me._updateTopMenuCount(result.filter(function (r) { return !!r.Active; }).length);
            });
        } catch (e) { me._writeErr(e); }
    },

    _generateOverviewList: function (rows) {
        /// <summary>
        /// Renders the AutoReport overview list rows.
        /// </summary>
        var me = this;
        try {
            var listData = me.myHtml.overview.listData;
            listData.empty();

            if (!rows.length) {
                listData.html($("<div>").addClass("note").text(me.resources.noEntriesExist));
                return;
            }

            rows.forEach(function (r) {
                var tooltip = me.specific.isAdmin ? "ID: " + r.Id + ", Report ID: " + (r.ReportId || "–") : "";
                var item = $("<div>").addClass("vc-list-item").css("cursor", "pointer").attr("title", tooltip);
                var inner = $("<div>").addClass("vc-list-col");

                // active status icon
                var colActive = $("<div>").addClass("vc-list-col-element ar-col-active");
                var activeIcon = !!r.Active ? $("<i>").addClass("fa fa-check icon-color-ok fa-2x") : $("<i>").addClass("fa-solid fa-minus icon-color-error fa-2x");
                colActive.append(activeIcon);

                // name
                var colName = $("<div>").addClass("vc-list-col-element ar-col-name");
                colName.append(me._renderTruncated(r.Name || ""));

                // description
                var colDesc = $("<div>").addClass("vc-list-col-element ar-col-description");
                if (r.Description && r.Description.trim().length > 0) {
                    colDesc.append(me._renderTruncatedHtml(r.Description));
                } else {
                    colDesc.append($("<span>").addClass("ar-no-entry").text("–"));
                }

                // type – report name with truncation, between description and recipients
                var colType = $("<div>").addClass("vc-list-col-element ar-col-type");
                if (r.ReportName && r.ReportName.trim().length > 0) {
                    colType.append(me._renderTruncated(r.ReportName));
                } else {
                    colType.append($("<span>").addClass("ar-no-entry").text("–"));
                }

                // recipients
                var colRecipients = $("<div>").addClass("vc-list-col-element ar-col-recipients");
                if (r.Recipients && r.Recipients.trim().length > 0) {
                    colRecipients.append(me._renderTruncated(r.Recipients));
                } else {
                    colRecipients.append($("<span>").addClass("ar-no-entry").text("–"));
                }

                // frequency details
                var colFrequency = $("<div>").addClass("vc-list-col-element ar-col-frequency").html(me._renderFrequency(r.Frequency));

                // creator name
                var colCreator = $("<div>").addClass("vc-list-col-element ar-col-creator");
                if (r.CreatorName && r.CreatorName.trim().length > 0) {
                    colCreator.text(r.CreatorName);
                } else {
                    colCreator.append($("<span>").addClass("ar-no-entry").text("–"));
                }

                // sending indicator
                var colSending = $("<div>").addClass("vc-list-col-element ar-col-sending");
                var hasSending = !!(r.ManualExecution);
                colSending.append(hasSending ? $("<i>").addClass("fa fa-paper-plane ar-icon-sending vc-list-icon fa-2x color-font-secondary").attr({ title: me.specific.resources.sending || "wird gesendet...", "data-id": r.Id }) : $("<br/>"));

                // delete icon
                var colDelete = $("<div>").addClass("vc-list-col-element ar-col-delete");
                colDelete.append($("<i>").addClass("fa fa-trash icon-color-error ar-icon-delete vc-list-icon fa-2x").attr({ title: me.specific.resources.delete, "data-id": r.Id }));

                inner.append(colActive, colName, colDesc, colType, colRecipients, colFrequency, colCreator, colSending, colDelete);
                item.append(inner);

                item.off("click").on("click", function (e) {
                    if ($(e.target).closest(".ar-desc-toggle, .ar-icon-delete").length) return;
                    me._openEntry(r.Id);
                });

                listData.append(item);
            });

            me.myHtml.overview.listData.find(".vc-list-item:even").addClass("alt");
            me._postProcessTruncated();
        } catch (e) { me._writeErr(e); }
    },

    _renderFrequency: function (frequencyJson) {
        /// <summary>
        /// Parses the frequency JSON string or object and returns a human-readable summary.
        /// </summary>
        var me = this;
        try {
            if (!frequencyJson) return "";

            var f = typeof frequencyJson === "string" ? JSON.parse(frequencyJson) : frequencyJson;
            var r = me.specific.resources;
            var time = (f.Hour !== undefined ? f.Hour : f.hour) || "";

            // support both old (frequencyId) and new (FrequencyType) format
            var freqType = f.FrequencyType > 0 ? f.FrequencyType : (f.FrequencyId > 0 ? f.FrequencyId : -1);

            switch (parseInt(freqType, 10)) {
                case 1: // daily
                    return r.daily + ": " + time + "h";
                case 2: // weekly
                    var dayNames = [r.monday, r.tuesday, r.wednesday, r.thursday, r.friday, r.saturday, r.sunday];
                    var weekDay = f.WeekDay !== undefined ? f.WeekDay : f.weekday;
                    var dayName = (weekDay >= 1 && weekDay <= 7) ? dayNames[weekDay - 1] : "";
                    return r.weekly + ": " + dayName + " - " + time + "h";
                case 3: // monthly
                    var dom3 = f.DayOfMonth !== undefined ? f.DayOfMonth : f.dayOfMonth;
                    return r.monthly + ": " + r.day + " " + (dom3 || 1) + " - " + time + "h";
                case 4: // quarterly
                    var qm = f.QuarterMonth !== undefined ? f.QuarterMonth : f.quarterMonth;
                    var dom4 = f.DayOfMonth !== undefined ? f.DayOfMonth : f.dayOfMonth;
                    return r.quarterly + ": " + r.month + " " + (qm || 1) + ", " + r.day + " " + (dom4 || 1) + " - " + time + "h";
                case 5: // yearly
                    var monthNames = [r.january, r.february, r.march, r.april, r.may, r.june, r.july, r.august, r.september, r.october, r.november, r.december];
                    var ym = f.Month !== undefined ? f.Month : f.yearlyMonth;
                    var yd = f.DayOfMonth !== undefined ? f.DayOfMonth : f.yearlyDay;
                    var monthName = (ym >= 1 && ym <= 12) ? monthNames[ym - 1] : "";
                    return r.yearly + ": " + (yd || 1) + ". " + monthName + " - " + time + "h";
                default:
                    return "";
            }
        } catch (e) { return ""; }
    },

    _resetForm: function () {
        /// <summary>
        /// Resets all edit form fields to their initial empty/default state and clears dirty flag.
        /// </summary>
        var me = this;
        try {
            me._dirty = false;
            me._resetting = true;
            me._currentEditId = null;
            me._currentManualExeSent = false; // reset manualexe tracking

            var left = me.myHtml.editForm.editArea.leftBox;
            var right = me.myHtml.editForm.editArea.rightBox;

            left.txtName.val("");
            me._setInvalid(left.divName, "");

            left.txtFileName.val("");

            // clear description: set textarea directly, then sync to CLEditor iframe via refresh()
            me.reportDescriptionText = "";
            left.txtDescription.val("");
            if (me.reportDescriptionEditor) {
                me.reportDescriptionEditor.refresh();
            }
            me._setValid(left.divEditor);

            var sz = right.ddlRecipients && right.ddlRecipients[0] && right.ddlRecipients[0].selectize;
            if (sz) sz.clear(true);
            me.selectedRecipients = [];
            me._setInvalid(right.divRecipients, "");

            right.txtEmails.val("");
            me._setValid(right.divEmails);

            if (me.ddlHour) me.ddlHour.setValue(12, true);
            me._setValid(right.divHour);

            left.chbActive.prop("checked", true);

            if (me.ddlFrequency) me.ddlFrequency.setValue(1, true);
            me._renderExtraInfo(1);

            // populate report type options based on current top menu mode and reset to first option
            me._updateReportTypeOptions(me.myStatus.selectedReportMode);

            // reset language to first available option
            if (me.ddlLanguage) {
                var firstLang = me.ddlLanguage.options[Object.keys(me.ddlLanguage.options)[0]];
                if (firstLang) me.ddlLanguage.setValue(firstLang.Id, true);
            }

            // reset file format to default (xls)
            if (me.ddlFileFormat) {
                me._resetting = true;
                me.ddlFileFormat.setValue("xls", true);
                me._resetting = false;
            }

            // reset addToMedia checkbox
            if (right.chbAddToMedia) {
                me._resetting = true;
                right.chbAddToMedia.prop("checked", false);
                me._resetting = false;
            }

            // reset useNameAsEmailSubject checkbox
            if (left.chbUseNameAsEmailSubject) {
                me._resetting = true;
                left.chbUseNameAsEmailSubject.prop("checked", false);
                me._resetting = false;
            }

            // reset signal selection – "Alle Signale" is the default
            var sig = me.myHtml.editForm.editArea.signalBox;
            sig.chbAllSignals.prop("checked", true);
            sig.divList.find("input[type=checkbox]").prop("checked", false).prop("disabled", true);
            sig.txtFilter.val("");
            sig.divList.find(".ar-signal-item").show();
            sig.divList.scrollTop(0);

        } catch (e) { me._writeErr(e); }
        finally {
            me._resetting = false;
            me._dirty = false;
        }
    },

    _openEntry: function (id) {
        /// <summary>
        /// Loads a single AutoReport entry by id via fetchReports and opens the edit form.
        /// </summary>
        var me = this;
        try {
            me.getData({ TypeId: 3, LoggerId: id }, function (result) {
                if (!result || !Array.isArray(result) || !result.length) return;
                var r = result[0];

                me.myHtml.overview.hide();
                me.myHtml.editForm.show();
                me.myHtml.topmenu.btnCustomXls.button("disable");
                me.myHtml.topmenu.btnStandard.button("disable");

                me._resetForm();

                if (!me._editorInitialized) {
                    me._initTextEditor();
                    me._editorInitialized = true;
                }

                me._setHeightsWidths();
                me._currentEditId = id;

                var left = me.myHtml.editForm.editArea.leftBox;
                var right = me.myHtml.editForm.editArea.rightBox;

                // Active
                left.chbActive.prop("checked", !!r.Active);

                // Name
                left.txtName.val(r.Name || "");
                me._validateName();

                // Description
                if (r.Description) {
                    me._resetting = true;
                    me.reportDescriptionText = r.Description;
                    left.txtDescription.val(r.Description);
                    if (me.reportDescriptionEditor) me.reportDescriptionEditor.refresh();
                    me._resetting = false;
                }

                // Recipients – UserIds is now List<int> directly
                var sz = right.ddlRecipients && right.ddlRecipients[0] && right.ddlRecipients[0].selectize;
                if (sz && Array.isArray(r.UserIds) && r.UserIds.length > 0) {
                    r.UserIds.forEach(function (uid) { sz.addItem(String(uid), true); });
                    me._validateRecipients();
                }

                // External emails – ExtEmails is List<string>
                right.txtEmails.val(Array.isArray(r.ExtEmails) && r.ExtEmails.length > 0 ? r.ExtEmails.join("; ") : "");
                me._validateEmails();

                // Frequency – already a deserialized Entry object (no JSON.parse needed)
                if (r.Frequency) {
                    var f = r.Frequency;

                    // FrequencyType: new format (Data.Frequency.Entry)
                    // fallback to old frequencyId for entries saved before the migration
                    // FrequencyType = new field, FrequencyId = old field (frequencyId in DB)
                    var freqId = f.FrequencyType > 0 ? f.FrequencyType : (f.FrequencyId > 0 ? f.FrequencyId : 1);
                    var fHour = (f.Hour !== undefined && f.Hour >= 0) ? f.Hour : 0;

                    if (me.ddlFrequency) me.ddlFrequency.setValue(freqId, true);
                    me._renderExtraInfo(freqId);

                    me._resetting = true;
                    var fWeekDay = f.WeekDay > 0 ? f.WeekDay : (f.weekday || 0);
                    var fDayOfMonth = f.DayOfMonth > 0 ? f.DayOfMonth : (f.dayOfMonth || 0);
                    var fQuarterMonth = f.QuarterMonth > 0 ? f.QuarterMonth : (f.quarterMonth || 0);
                    var fYearlyMonth = f.Month > 0 ? f.Month : (f.yearlyMonth || 0);

                    if (fWeekDay && freqId === 2) { var szWd = me.fnd("#ddl-report-weekday"); if (szWd[0] && szWd[0].selectize) { szWd[0].selectize.setValue(fWeekDay, true); me.scheduleExtra.weekday = fWeekDay; } }
                    if (fDayOfMonth && freqId === 3) { var szDom = me.fnd("#ddl-report-dayofmonth"); if (szDom[0] && szDom[0].selectize) { szDom[0].selectize.setValue(fDayOfMonth, true); me.scheduleExtra.dayOfMonth = fDayOfMonth; } }
                    if (fQuarterMonth && freqId === 4) { var szQm = me.fnd("#ddl-report-qmonth"); if (szQm[0] && szQm[0].selectize) { szQm[0].selectize.setValue(fQuarterMonth, true); me.scheduleExtra.quarterMonth = fQuarterMonth; } }
                    if (fDayOfMonth && freqId === 4) { var szQd = me.fnd("#ddl-report-qday"); if (szQd[0] && szQd[0].selectize) { szQd[0].selectize.setValue(fDayOfMonth, true); me.scheduleExtra.quarterDay = fDayOfMonth; } }
                    if (fYearlyMonth && freqId === 5) { var szYm = me.fnd("#ddl-report-yearly-month"); if (szYm[0] && szYm[0].selectize) { szYm[0].selectize.setValue(fYearlyMonth, true); me.scheduleExtra.yearlyMonth = fYearlyMonth; } }
                    if (fDayOfMonth && freqId === 5) { var szYd = me.fnd("#ddl-report-yearly-day"); if (szYd[0] && szYd[0].selectize) { szYd[0].selectize.setValue(fDayOfMonth, true); me.scheduleExtra.yearlyDay = fDayOfMonth; } }
                    me._resetting = false;

                    if (me.ddlHour) {
                        me._resetting = true;
                        me.ddlHour.setValue(fHour, true);
                        me._resetting = false;
                    }
                    me._validateHour();
                }

                // Settings – already a deserialized Settings object
                var fileType = "xls";
                var s = r.Settings;
                if (s) {
                    var ft = parseInt(s.FileType, 10);
                    if (ft === 1) fileType = "pdf";
                    else if (ft === 3) fileType = "xlspdf";
                    else fileType = "xls";

                    if (left.txtFileName) {
                        me._resetting = true;
                        left.txtFileName.val(s.FileName || "");
                        me._resetting = false;
                    }
                }

                if (me.ddlFileFormat) {
                    me._resetting = true;
                    me.ddlFileFormat.setValue(fileType, true);
                    me._resetting = false;
                }

                if (right.chbAddToMedia) {
                    me._resetting = true;
                    right.chbAddToMedia.prop("checked", !!(s && s.AddToMedia));
                    me._resetting = false;
                }

                if (left.chbUseNameAsEmailSubject) {
                    me._resetting = true;
                    left.chbUseNameAsEmailSubject.prop("checked", !!(s && s.UseNameAsEmailSubject));
                    me._resetting = false;
                }

                // TypeId: 1 = customXls, 2 = standard
                var entryMode = (r.TypeId === 2) ? "standard" : "customXls";
                var bsaidsToRestore = (entryMode === "standard" && s && Array.isArray(s.Bsaids)) ? s.Bsaids : null;

                me._updateReportTypeOptions(entryMode, function () {
                    me._resetting = true;
                    me._setSelectedBsaids(bsaidsToRestore && bsaidsToRestore.length > 0 ? bsaidsToRestore : [-1]);
                    me._resetting = false;
                });

                if (me.ddlReportType && r.ReportId > 0) {
                    me._resetting = true;
                    me.ddlReportType.setValue(r.ReportId, true);
                    me._checkHideAddMedia();
                    me._updateManualDateBox(r.ReportId);
                    me._resetting = false;
                }

                if (me.ddlLanguage && r.LangId > 0) {
                    me._resetting = true;
                    me.ddlLanguage.setValue(r.LangId, true);
                    me._resetting = false;
                }

                me._dirty = false;
                me._updateSaveButtonStatus();

                // ManualExecution is now a deserialized object (or null) – no string check needed
                var manual = me.myHtml.editForm.editArea.manualBox;
                if (manual && manual.btnSend) {
                    var sendLbl = me.specific.resources.send || "Senden";
                    var sendingLbl = me.specific.resources.sending || "wird gesendet...";
                    me._currentManualExeSent = !!(r.ManualExecution);
                    manual.btnSend.button("option", "label", me._currentManualExeSent ? sendingLbl : sendLbl);
                    if (me._currentManualExeSent) {
                        manual.btnSend.button("disable");
                    } else {
                        manual.btnSend.button("enable");
                    }
                }
            });
        } catch (e) { me._writeErr(e); }
    },

    _validateEmails: function () {
        /// <summary>
        /// Validates that all entered email addresses have a valid format.
        /// Accepts semicolon, comma or space as separator. The field is optional – empty is always valid.
        /// </summary>
        var me = this;
        try {
            var right = me.myHtml.editForm.editArea.rightBox;
            var raw = right.txtEmails.val() || "";
            if (raw.trim().length === 0) {
                me._setValid(right.divEmails);
                return true;
            }
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            var parts = raw.split(/[;,\s]+/).map(function (v) { return v.trim(); }).filter(function (v) { return v.length > 0; });
            var allValid = parts.every(function (e) { return emailRegex.test(e); });
            if (allValid) {
                me._setValid(right.divEmails);
            } else {
                me._setInvalid(right.divEmails, me.specific.resources.ERR_inputInvalid || "Ungültige E-Mail-Adresse");
            }
            return allValid;
        } catch (e) { me._writeErr(e); return false; }
    },

    _validateSignalSelection: function () {
        /// <summary>
        /// For standard reports: either "Alle Signale" is checked OR at least one individual signal is checked.
        /// </summary>
        var me = this;
        try {
            if (me.myStatus.selectedReportMode !== "standard") return true;

            var sig = me.myHtml.editForm.editArea.signalBox;
            if (!sig || !sig.wrapper || !sig.wrapper.is(":visible")) return true;

            var isAll = sig.chbAllSignals.prop("checked");
            var hasSignal = sig.divList.find("input[type=checkbox]:checked").length > 0;
            var ok = isAll || hasSignal;

            sig.divList.css("border-color", ok ? "#ddd" : "#d9534f");
            sig.divList.toggleClass("formItemInvalid", !ok);
            return ok;
        } catch (e) { me._writeErr(e); return false; }
    },

    _renderReportType: function (typeId) {
        /// <summary>
        /// Returns the report type label for the overview list.
        /// </summary>
        switch (parseInt(typeId, 10)) {
            case 1: return "xls";
            case 2: return "Standard";
            default: return "";
        }
    },

    _renderTruncated: function (text) {
        /// <summary>
        /// Renders plain text with a collapsible toggle button. Escapes HTML entities.
        /// </summary>
        var escaped = $("<div>").text(text).html();
        var wrap = $("<div>").addClass("ar-text-wrap").html(escaped);
        var btn = $('<button type="button" class="ar-desc-toggle" aria-expanded="false" title="mehr anzeigen" style="display:none">' + '<i class="fa-solid fa-chevron-down" aria-hidden="true"></i>' + '</button>');
        return $("<div>").append(wrap, btn);
    },

    _renderTruncatedHtml: function (html) {
        /// <summary>
        /// Renders raw HTML (e.g. from CLEditor) with a collapsible toggle button.
        /// HTML is inserted directly via .html(), same as Activities._renderDesc.
        /// </summary>
        var wrap = $("<div>").addClass("ar-text-wrap").html(html);
        var btn = $('<button type="button" class="ar-desc-toggle" aria-expanded="false" title="mehr anzeigen" style="display:none">' + '<i class="fa-solid fa-chevron-down" aria-hidden="true"></i>' + '</button>');
        return $("<div>").append(wrap, btn);
    },

    _postProcessTruncated: function () {
        /// <summary>
        /// Checks all truncatable cells and shows/hides the toggle button accordingly.
        /// Also shows the toggle if the cell contains <br> tags (= line breaks).
        /// </summary>
        var me = this;
        try {
            me.myHtml.overview.listData.find(".ar-text-wrap").each(function () {
                var el = $(this);
                var elem = this;
                var isTruncated = elem.scrollHeight > elem.clientHeight + 1;
                var hasLineBreak = el.html().indexOf("<br>") > -1;
                var needsToggle = isTruncated || hasLineBreak;

                el.toggleClass("truncated", needsToggle);
                var btn = el.next(".ar-desc-toggle");
                if (!btn.length) return;
                btn.toggle(needsToggle);
                if (!needsToggle) {
                    el.removeClass("expanded");
                    btn.find("i").removeClass("fa-chevron-up").addClass("fa-chevron-down");
                    btn.attr("aria-expanded", "false");
                }
            });
        } catch (e) { me._writeErr(e); }
    },

    _selectReportMode: function (mode) {
        /// <summary>
        /// Switches the active report mode and updates the top menu button states.
        /// </summary>
        var me = this;
        try {
            me.myStatus.selectedReportMode = mode;
            me.myHtml.topmenu.btnCustomXls.toggleClass("button-toggle-active", mode === "customXls");
            me.myHtml.topmenu.btnStandard.toggleClass("button-toggle-active", mode === "standard");
            me._updateNoReportsWarning();
            me._fetchOverview();
        } catch (e) { me._writeErr(e); }
    },

    _updateReportTypeOptions: function (mode, onSignalsLoaded) {
        var me = this;
        try {
            var right = me.myHtml.editForm.editArea.rightBox;
            var sig = me.myHtml.editForm.editArea.signalBox;
            var manual = me.myHtml.editForm.editArea.manualBox;
            if (!right || !right.ddlXlsWrap || !right.ddlStdWrap) return;

            var isStandard = mode === "standard";

            right.ddlXlsWrap.toggle(!isStandard);
            right.ddlStdWrap.toggle(isStandard);
            right.divFileFormat.toggle(!isStandard);

            var left = me.myHtml.editForm.editArea.leftBox;
            if (left && left.divFileName) {
                left.divFileName.toggle(isStandard);
            }

            if (sig && sig.wrapper) {
                sig.wrapper.toggle(isStandard);
                if (isStandard && !me._signalsLoaded) {
                    me._loadSignalList(onSignalsLoaded);
                } else if (typeof onSignalsLoaded === "function") {
                    onSignalsLoaded();
                }
            }

            // manual execution box: only for admins in standard mode
            if (manual && manual.wrapper) {
                var showManual = isStandard && !!me.specific.isAdmin;
                manual.wrapper.toggle(showManual);
                if (showManual) {
                    me._initDateBox();
                }
            }

            me.ddlReportType = isStandard ? me.ddlReportTypeStd : me.ddlReportTypeXls;

            me._resetting = true;
            me.ddlReportType.setValue(1, true);
            me._resetting = false;

            me._checkHideAddMedia();
        } catch (e) { me._writeErr(e); }
    },

    _prefillRecipientsFromUids: function (uids) {
        /// <summary>
        /// Pre-selects the given UIDs in the recipients DDL.
        /// UIDs come directly from the report option – no extra server call needed.
        /// </summary>
        var me = this;
        try {
            var right = me.myHtml.editForm.editArea.rightBox;
            var sz = right.ddlRecipients && right.ddlRecipients[0] && right.ddlRecipients[0].selectize;
            if (!sz) return;

            me._resetting = true;
            sz.clear(true);
            uids.forEach(function (uid) {
                if (uid) sz.addItem(String(uid), true);
            });
            me._resetting = false;

            me._dirty = true;
            me._validateRecipients();
            me._updateSaveButtonStatus();
        } catch (e) { me._writeErr(e); }
    },

    _initHourDropdown: function () {
        /// <summary>
        /// Initializes the hour Selectize dropdown with options 0-23.
        /// </summary>
        var me = this;
        try {
            var right = me.myHtml.editForm.editArea.rightBox;
            var hourOptions = Array.from({ length: 24 }, function (_, i) {
                return { Id: i, Name: i + ":00" };
            });

            right.ddlHour.selectize({
                create: false,
                maxItems: 1,
                valueField: "Id",
                labelField: "Name",
                searchField: "Name",
                options: hourOptions,
                dropdownParent: "body",
                onChange: function (value) {
                    if (!me._resetting) {
                        me._dirty = true;
                        me._validateHour();
                        me._updateSaveButtonStatus();
                    }
                }
            });

            me.ddlHour = right.ddlHour[0].selectize;
            me._resetting = true;
            me.ddlHour.setValue(12, true);
            me._setValid(right.divHour);
            me._resetting = false;

        } catch (e) { me._writeErr(e); }
    },


    _initFileFormatDropdown: function () {
        /// <summary>
        /// Initializes the file format Selectize dropdown (xls / pdf / xls+pdf).
        /// </summary>
        var me = this;
        try {
            var right = me.myHtml.editForm.editArea.rightBox;
            var options = [
                { Id: "xls", Name: me.specific.resources.exportOnlyExcel },
                { Id: "pdf", Name: me.specific.resources.exportOnlyPDF },
                { Id: "xlspdf", Name: me.specific.resources.exportExcelAndPDF }
            ];

            right.ddlFileFormat.selectize({
                create: false,
                maxItems: 1,
                valueField: "Id",
                labelField: "Name",
                searchField: "Name",
                options: options,
                dropdownParent: "body",
                onChange: function () {
                    if (!me._resetting) { me._dirty = true; me._updateSaveButtonStatus(); }
                }
            });

            me.ddlFileFormat = right.ddlFileFormat[0].selectize;
            me._resetting = true;
            me.ddlFileFormat.setValue("xls", true);
            me._resetting = false;

        } catch (e) { me._writeErr(e); }
    },


    _initDateBox: function () {
        var me = this;
        try {
            if (!me.specific.isAdmin) return;

            var manual = me.myHtml.editForm.editArea.manualBox;
            var langId = me.specific.userLangIDForCulture || me.specific.userLangID || 2;

            if (manual.calDay.hasClass("vc-date")) manual.calDay.vcDate("destroy");
            if (manual.calMonth.hasClass("vc-date")) manual.calMonth.vcDate("destroy");
            if (manual.calYear.hasClass("vc-date")) manual.calYear.vcDate("destroy");

            var today = new Date();
            var dd = String(today.getDate()).padStart(2, "0");
            var mm = String(today.getMonth() + 1).padStart(2, "0");
            var yyyy = String(today.getFullYear());


            manual.calDay.vcDate({
                mode: "Single", align: "center", interval: 1, langID: langId,
                callback: function (obj) {  }
            });
            manual.calMonth.vcDate({
                mode: "Single", align: "center", interval: 3, langID: langId,
                callback: function (obj) { }
            });
            manual.calYear.vcDate({
                mode: "Single", align: "center", interval: 5, langID: langId,
                callback: function (obj) { }
            });

            var currentValue = me.ddlReportTypeStd ? me.ddlReportTypeStd.getValue() : null;
            me._updateManualDateBox(currentValue);

        } catch (e) { me._writeErr(e); }
    },

        _sendManual: function () {
        var me = this;
        try {
            if (!me._currentEditId || me._currentEditId <= 0) return;

            var manual = me.myHtml.editForm.editArea.manualBox;
            var sendLbl    = me.specific.resources.send    || "Senden";
            var sendingLbl = me.specific.resources.sending || "wird gesendet...";

            // getDate() - we convert it to the correct format depending on which interval is currently visible (day/month/year)
            var date = null;
            if (manual.divDateDay.is(":visible") && manual.calDay.hasClass("vc-date")) {
                // interval 1: day → DD.MM.YYYY
                var r1 = manual.calDay.vcDate("getDate");
                if (r1 && r1.from) date = r1.from;
            }
            if (manual.divDateMonth.is(":visible") && manual.calMonth.hasClass("vc-date")) {
                // interval 3: month → MM.YYYY
                var r3 = manual.calMonth.vcDate("getDate");
                if (r3 && r3.from) date = moment(r3.from, "DD.MM.YYYY").format("MM.YYYY");
            }
            if (manual.divDateYear.is(":visible") && manual.calYear.hasClass("vc-date")) {
                // interval 5: year → YYYY
                var r5 = manual.calYear.vcDate("getDate");
                if (r5 && r5.from) date = moment(r5.from, "DD.MM.YYYY").format("YYYY");
            }

            manual.btnSend.button("disable").button("option", "label", sendingLbl);

            me.updateData({ TypeId: 5, Id: me._currentEditId, Date: date }, function (result) {
                if (!result || !result.Success) {
                    manual.btnSend.button("enable").button("option", "label", sendLbl);
                } else {
                    me._currentManualExeSent = true;
                }
            });

        } catch (e) { me._writeErr(e); }
    },

    _fetchAllTopMenuCounts: function () {
        /// <summary>
        /// Fetches the report counts for both modes (customXls + standard) in parallel and updates both top menu button labels independently.
        /// Called once on widget init so both counts are visible from the start.
        /// Only active reports are counted.
        /// </summary>
        var me = this;
        try {
            me.getData({ TypeId: 2, ReportTypeFilter: 1 }, function (result) {
                var count = Array.isArray(result) ? result.filter(function (r) { return !!r.Active; }).length : 0;
                me._updateTopMenuCount(count, "customXls");
            });

            me.getData({ TypeId: 2, ReportTypeFilter: 2 }, function (result) {
                var count = Array.isArray(result) ? result.filter(function (r) { return !!r.Active; }).length : 0;
                me._updateTopMenuCount(count, "standard");
            });
        } catch (e) { me._writeErr(e); }
    },

    _updateTopMenuCount: function (count, mode) {
        /// <summary>
        /// Updates the top menu button labels with the current report count.
        /// If mode is not given, the currently active mode is used.
        /// </summary>
        var me = this;
        try {
            var targetMode = mode || me.myStatus.selectedReportMode;
            var countSuffix = (count !== null && count !== undefined) ? " (" + count + ")" : "";

            if (targetMode !== "standard") {
                me.myHtml.topmenu.btnCustomXls.button("option", "label", "XLS - " + me.specific.resources.reports + countSuffix);
            } else {
                me.myHtml.topmenu.btnStandard.button("option", "label", me.specific.resources.default + " - " + me.specific.resources.reports + countSuffix);
            }
        } catch (e) { me._writeErr(e); }
    },

    _updateNoReportsWarning: function () {
        /// <summary>
        /// Shows a warning in the overview if no custom XLS reports are available for this project.
        /// Standard reports always have options, so the warning only applies to customXls mode.
        /// </summary>
        var me = this;
        try {
            var isStandard = me.myStatus.selectedReportMode === "standard";

            // standard reports always have options – warning is never relevant there
            if (isStandard) {
                me.myHtml.overview.divNoReports.hide();
                me.myHtml.overview.btnNew.show();
                return;
            }

            // for customXls: check if any XLS reports are assigned to this project
            var hasOptions = me.ddlReportTypeXls && Object.keys(me.ddlReportTypeXls.options).length > 0;
            me.myHtml.overview.divNoReports.toggle(!hasOptions);
            me.myHtml.overview.btnNew.toggle(hasOptions);
        } catch (e) { me._writeErr(e); }
    },

    _loadSignalList: function (onLoaded) {
        /// <summary>
        /// Loads all signals for the current project and renders them as a checkable list.
        /// Called once when standard mode is first opened.
        /// Optional onLoaded callback is invoked after the list is fully rendered.
        /// </summary>
        var me = this;
        try {
            var sig = me.myHtml.editForm.editArea.signalBox;
            sig.divList.html(me.getLoadingIcon());

            me.getData({ TypeId: 6 }, function (result) {
                sig.divList.empty();
                me._signalsLoaded = true;

                var rows = [];
                if (result && Array.isArray(result)) {
                    rows = result;
                } else if (result && Array.isArray(result.rows)) {
                    rows = result.rows;
                }

                if (!rows.length) {
                    sig.divList.html($("<div>").addClass("note").text(me.resources.noEntriesExist));
                    if (typeof onLoaded === "function") onLoaded();
                    return;
                }

                me._allSignalRows = rows;

                rows.forEach(function (r) {
                    var id = r.id || r.Id;
                    var name = $("<div>").html(r.name || r.Name || "").text();
                    var dims = $("<div>").html(r.dims || r.Dims || "").text();

                    var item = $("<div>").addClass("ar-signal-item vc-list-item").css({ display: "flex", gap: "6px", alignItems: "center", padding: "3px 4px" });
                    var chb = $("<input>").attr({ type: "checkbox", id: "chb-sig-" + id }).val(id);
                    var lbl = $("<label>").attr("for", "chb-sig-" + id)
                        .text(name + (dims ? " [" + dims + "]" : ""))
                        .css({ cursor: "pointer", flex: "1", "font-weight": "normal" });

                    chb.off("change").on("change", function () {
                        if (!me._resetting) {
                            me._dirty = true;
                            me._validateSignalSelection();
                            me._updateSaveButtonStatus();
                        }
                    });

                    item.append(chb, lbl);
                    sig.divList.append(item);
                });

                // apply initial disabled state if "Alle Signale" is already checked
                if (sig.chbAllSignals.prop("checked")) {
                    sig.divList.find("input[type=checkbox]").prop("disabled", true);
                }

                // init live filter
                sig.txtFilter.off("input").on("input", function () {
                    var q = $(this).val().toLowerCase();
                    sig.divList.find(".ar-signal-item").each(function () {
                        $(this).toggle($(this).text().toLowerCase().indexOf(q) > -1);
                    });
                });

                if (typeof onLoaded === "function") onLoaded();
            });
        } catch (e) { me._writeErr(e); }
    },

    _getSelectedBsaids: function () {
        /// <summary>
        /// Returns [-1] if "Alle Signale" is checked, otherwise returns the list of checked bsaids.
        /// </summary>
        var me = this;
        try {
            var sig = me.myHtml.editForm.editArea.signalBox;
            if (sig.chbAllSignals.prop("checked")) return [-1];

            var ids = [];
            sig.divList.find("input[type=checkbox]:checked").each(function () {
                var v = parseInt($(this).val(), 10);
                if (!isNaN(v)) ids.push(v);
            });
            return ids;
        } catch (e) { me._writeErr(e); return []; }
    },

    _setSelectedBsaids: function (bsaids) {
        /// <summary>
        /// If bsaids = [-1], checks "Alle Signale" and disables individual checkboxes.
        /// Otherwise checks the matching individual checkboxes and moves them to the top.
        /// </summary>
        var me = this;
        try {
            if (!Array.isArray(bsaids)) return;
            var sig = me.myHtml.editForm.editArea.signalBox;
            var isAll = (bsaids.length === 1 && bsaids[0] === -1);

            me._resetting = true;
            sig.chbAllSignals.prop("checked", isAll);
            sig.divList.find("input[type=checkbox]").prop("disabled", isAll);

            if (!isAll) {
                sig.divList.css("opacity", 1);
                sig.divList.find("input[type=checkbox]").each(function () {
                    $(this).prop("checked", bsaids.indexOf(parseInt($(this).val(), 10)) > -1);
                });

                // move checked items to the top of the list
                sig.divList.find(".ar-signal-item").sort(function (a, b) {
                    var aChecked = $(a).find("input[type=checkbox]").prop("checked") ? 0 : 1;
                    var bChecked = $(b).find("input[type=checkbox]").prop("checked") ? 0 : 1;
                    return aChecked - bChecked;
                }).appendTo(sig.divList);
            }
            else {
                sig.divList.css("opacity", 0.5);
            }

            sig.divList.scrollTop(0);
            me._resetting = false;
        } catch (e) { me._writeErr(e); }
    },

    _checkHideAddMedia: function () {
        /// <summary>
        /// Shows or hides the AddToMedia checkbox depending on the HideAddMedia flag
        /// of the currently selected standard report. Only relevant in standard mode.
        /// </summary>
        var me = this;
        try {
            var right = me.myHtml.editForm.editArea.rightBox;
            if (!right || !right.divAddToMedia) return;

            var isStandard = me.myStatus.selectedReportMode === "standard";
            if (!isStandard) {
                right.divAddToMedia.show();
                return;
            }

            var selectedValue = me.ddlReportTypeStd ? me.ddlReportTypeStd.getValue() : null;
            if (!selectedValue) {
                right.divAddToMedia.show();
                return;
            }

            var opt = me.ddlReportTypeStd.options[selectedValue];
            var hide = opt && opt.HideAddMedia === true;
            right.divAddToMedia.toggle(!hide);

            // uncheck when hidden so the value is not accidentally saved as true
            if (hide && right.chbAddToMedia) {
                right.chbAddToMedia.prop("checked", false);
            }
        } catch (e) { me._writeErr(e); }
    },

    _updateManualDateBox: function (value) {
        /// <summary>
        /// Shows the correct date box in the manual execution box based on the
        /// Interval property of the selected standard report type.
        /// Interval 1 = Day, 3 = Month, 5 = Year.
        /// </summary>
        var me = this;
        try {
            var manual = me.myHtml.editForm.editArea.manualBox;
            if (!manual || !manual.wrapper || !manual.wrapper.is(":visible")) return;

            var interval = 1; // default: day
            var key = value || (me.ddlReportTypeStd ? me.ddlReportTypeStd.getValue() : null);
            if (key && me.ddlReportTypeStd) {
                var opt = me.ddlReportTypeStd.options[key];
                if (opt && opt.Interval) interval = parseInt(opt.Interval, 10);
            }

            manual.divDateDay.toggle(interval === 1);
            manual.divDateMonth.toggle(interval === 3);
            manual.divDateYear.toggle(interval === 5);

        } catch (e) { me._writeErr(e); }
    },


    _startSendingPoller: function () {
        /// <summary>
        /// Starts a timer that polls the manualexe status every 30 seconds and updates
        /// the sending icon in the overview list without re-rendering the entire list.
        /// </summary>
        var me = this;
        try {
            if (me._sendingPollTimer) clearInterval(me._sendingPollTimer);

            me._sendingPollTimer = setInterval(function () {
                me._pollSendingStatus();
            }, 10000);
        } catch (e) { me._writeErr(e); }
    },

    _pollSendingStatus: function () {
        var me = this;
        try {
            if (!me.myHtml.overview.is(":visible")) return;
            if (!me.myHtml.overview.listData.find(".vc-list-item").length) return;

            var reportTypeFilter = me.myStatus.selectedReportMode === "standard" ? 2 : 1;

            me.getData({ TypeId: 2, ReportTypeFilter: reportTypeFilter }, function (result) {
                if (!result || !Array.isArray(result)) return;

                var statusMap = {};
                result.forEach(function (r) {
                    statusMap[r.Id] = !!(r.ManualExecution);
                });

                me.myHtml.overview.listData.find(".vc-list-item").each(function () {
                    var row = $(this);
                    var id = parseInt(row.find(".ar-icon-delete").attr("data-id"), 10);
                    if (!id || !(id in statusMap)) return;

                    var colSending = row.find(".ar-col-sending");
                    var hasSending = statusMap[id];
                    var hasIcon = colSending.find(".ar-icon-sending").length > 0;

                    if (hasSending && !hasIcon) {
                        colSending.empty().append(
                            $("<i>").addClass("fa fa-paper-plane ar-icon-sending vc-list-icon fa-2x color-font-secondary").attr({ title: me.specific.resources.sending || "wird gesendet...", "data-id": id })
                        );
                    } else if (!hasSending && hasIcon) {
                        colSending.empty().append($("<br/>"));
                    }
                });
            });
        } catch (e) { me._writeErr(e); }
    },

});
